import { Card } from '../components/kit';
import { useAuth } from '../auth/AuthContext';
import './page.css';

export function Profile() {
  const { user } = useAuth();
  if (!user) return null;

  const rows: [string, string][] = [
    ['Ad Soyad', user.full_name || '—'],
    ['E-posta', user.email],
    ['Rol', user.role === 'bayi' ? 'Bayi' : user.role === 'manager' ? 'Manager' : 'Yönetici'],
    ['Firma Adı', user.company_name || '—'],
    ['Vergi No', user.tax_number || '—'],
    ['Telefon', user.phone || '—'],
    ['Adres', user.address || '—'],
  ];

  return (
    <div className="page">
      <div className="page-head">
        <div className="page-eyebrow">Hesap</div>
        <h1>Profilim</h1>
      </div>
      <Card>
        <dl className="info-list">
          {rows.map(([k, v]) => (
            <div className="info-row" key={k}>
              <dt>{k}</dt>
              <dd>{v}</dd>
            </div>
          ))}
        </dl>
      </Card>
    </div>
  );
}
